import { render, staticRenderFns } from "./LayoutVerticalSimple.vue?vue&type=template&id=1f2ef784&scoped=true"
import script from "./LayoutVerticalSimple.vue?vue&type=script&lang=js"
export * from "./LayoutVerticalSimple.vue?vue&type=script&lang=js"
import style0 from "./LayoutVerticalSimple.vue?vue&type=style&index=0&id=1f2ef784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ef784",
  null
  
)

export default component.exports